<template>
  <div class="wrap" style="min-width: 1000px">
    <card style="width:100%;height: 11%;position: absolute;top: 0px;">
      <!--<img src="" alt="" style="width: 239px;height: 40px;position:absolute;left: 240px;top: 20px;">-->
      <div class="nav-right">
        <Icon type="person" class="nav-icon"></Icon>
        立即注册 丨
        <Icon type="ios-analytics" class="nav-icon"></Icon>
        <select style="border: 0;">
          <option value="简体中文">简体中文</option>
          <option value="繁体中文">繁体中文</option>
          <option value="英文">英文</option>
        </select>
      </div>
    </card>
    <Card class="card" v-if="status" style="min-width: 300px;min-height: 300px">
      <p class="login-avatar">登录</p>
      <Form ref="loginForm" :model="loginForm" class="login" :rules="loginRule">
        <FormItem prop="account" key="login-account" style="margin-top: 5%">
          <Input type="text" placeholder="邮箱/微信号/QQ号" v-model="loginForm.account" >
          <Icon type="person" slot="prepend" size="16"></Icon>
          </Input>
        </FormItem>
        <FormItem prop="password" key="login-password">
          <Input type="password" placeholder="密码" v-model="loginForm.password" @keyup.enter.native="login">
            <Icon type="locked" slot="prepend" size="14"></Icon>
          </Input>
        </FormItem>
        <FormItem class="remember-account">
          <input type="checkbox" style="float: left" />
          <p style="margin-left: 6%;float: left" >记住账号</p>
          <p style="float: right">忘记账号或密码</p>
        </FormItem>
        <FormItem>
          <Button type="primary" v-on:click="login" style="width: 35%;float: left;min-width: 100px;margin-bottom: 5%">登录</Button>
        </FormItem>
      </Form>
      <div class="card-tip" v-show="errorCount > 3">
        <Alert type="error" show-icon>错误次数超过3次&emsp;<router-link to="/registe">注册</router-link></Alert>
      </div>
    </Card>
    <Card class="card" v-else>
      <Avatar class="registe-avatar" icon="person" size="large" />
      <Form class="registe" ref="registeForm" :model="registeForm" :rules="registeRule">
        <FormItem prop="account" key="registe-account">
          <Input type="text" placeholder="账号" v-model="registeForm.account">
            <Icon type="person" slot="prepend" size="16"></Icon>
          </Input>
        </FormItem>
        <FormItem prop="password" key="registe-password">
          <Input type="password" placeholder="密码" v-model="registeForm.password">
            <Icon type="locked" slot="prepend" size="14"></Icon>
          </Input>
        </FormItem>
        <FormItem prop="confirm" key="registe-confirm">
          <Input type="password" placeholder="确认密码" v-model="registeForm.confirm">
            <Icon type="locked" slot="prepend" size="14"></Icon>
          </Input>
        </FormItem>
        <FormItem>
          <Button type="primary" long v-on:click="registe">注册</Button>
        </FormItem>
      </Form>
    </Card>
    <div  style="width:100%;height: 11%;position: absolute;bottom: 0px;background-color:#fff;">
	<ul style="display: flex;align-items: center;flex-direction: column;list-style: none;justify-content: center; height: 100%">
		  <li class="info">Copyright © 2017-2021 All rights reserved 版权所有 © 无障碍科技</li>
		  <li class="info"><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">鄂ICP备18005954号</a></li>
		</ul>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
import Input from "iview/src/components/input/input";
import Card from "iview/src/components/card/card";

export default {
  components: {
    Card,
    Input},
  name: "home",
  props: ["status"],
  data () {
    const validPwd = (rule, value, callback, source, options) => {
      if(value === ""){
        callback(new Error("input valid password"));
      }else{
         console.log(this.registeForm.confirm);
        if(this.registeForm.confirm !== "") {
          this.$refs.registeForm.validateField("confirm");
        }
        callback();
      }
    };
    const validConfirm = (rule, value, callback, source, options) => {
      if(value === ""){
        callback(new Error("input valid password again"));
      }else if(value !== this.registeForm.password){
        callback(new Error('The two input passwords do not match!'));
      }else{
        callback();
      }
    };
    return {
      errorCount: 0,
      loginForm: {
        account: "",
        password: ""
      },
      registeForm: {
        account: "",
        password: "",
        confirm: ""
      },
      loginRule: {
        account: [{
          required: true,
          message: "input valid accout",
        }],
        password: [{
          required: true,
          message: "input valid password",
        }]
      },
      registeRule: {
        account: [{
          required: true,
          message: "input valid accout",
          trigger: "blur",
        }],
        password: [{
          validator: validPwd,
          trigger: "blur"
        }],
        confirm: [{
          validator: validConfirm,
          trigger: "blur"
        }]
      }
    };
  },
  mounted(){
    if(utils.getCookie('username')) {
      console.log('1234');
    }
  },
  methods: {
    login(){
      this.$refs['loginForm'].validate((valid) => {
          if(this.loginForm.account===''||this.loginForm.password==='') {
            alert('请输入用户名或密码');
          } else {
            let data={'userName':this.loginForm.account, 'password':this.loginForm.password};
            this.$http.post('/zm/session/login', data).then(
              (res) => {
                // console.log(res);
                if (res.data.code === 0) {
                  this.$Message.success("登录成功!");
                  this.setUserInfo();
                  let currentTag = this.$store.state.currentTag;
                  if (currentTag) {
                    this.$router.push({
                      name: currentTag,
                      query: ""
                    });
                  } else {
                    let openedPage = localStorage.getItem("currentTag");
                    this.$router.push({
                      name: openedPage || "admin"
                    });
                  }
                } else {
                  this.$Message.error(res.data.errorMsg);
                }
              });
          }
      }
      );
      //重置表单
      this.$refs.loginForm.resetFields();
    },
    registe(){
      this.$refs['registeForm'].validate((valid) => {
        console.log(valid);
        if(valid){
          this.$Message.success("注册成功!");
        }else{
          this.$Message.error("注册失败!");
        }
      });
    },
    setUserInfo(){
      const user = this.loginForm.account;
      const uid = new Date().getTime().toString(16);
      utils.setCookie("user", user, 1);
      utils.setCookie("uid", uid, 1);
      // this.$store.commit("updateCurrentTag", "admin");
      if(typeof (Storage) !== "undefined"){
        localStorage.setItem("isLogin", true);
        // localStorage.setItem("currentTag", "admin");
        // localStorage.setItem("openedTags", JSON.stringify(this.$store.state.openedTags));
        // localStorage.setItem("currentPath", JSON.stringify(this.$store.state.currentPath));
      }else{
        console.error("your browser doesn't support localstorage and sessionstorage.");
      }
    }
  }
};
</script>

<style scoped>
.wrap{
  height: 100vh;
  width: 100%;
  background: #f8f8f9 url("../assets/images/bg.jpg") no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card{
  background-color: rgba(250,250,250,.93);
  width: 27%;
  height: 43%;
  text-align: center;
  padding: 15px 30px;
  position: absolute;
  left:56%;
  top: 18%;
}

.card .remember-account input{
  position: absolute;
  top:10px;
  left:4px;
}

.card .remember-account p{
  display: inline;
  font-size: 14px;
  color: rgba(106, 106, 106, 1);
}

.card .login-avatar{
  color: rgba(80, 80, 80, 1);
  font-size: 20px;
  font-family: 'Microsoft YaHei';
  line-height: 150%;
  text-align: left;
}

.nav-right{
  position: absolute;
  left: 68%;
  top: 30px;
  height: 20px;
  font-size: 14px;
  font-family: 'Microsoft YaHei';
}

.nav-icon{
  width: 20px;
  height: 20px;
  left: 983px;
  top: 30px;
  font-size: 20px;
  color: rgba(153, 153, 153, 1);
}


.card .registe-avatar{
  margin-bottom: 12px;
}
.card-tip{
  font-size: 10px;
  text-align: center;
  color: #c3c3c3;
}
.registe .ivu-form-item:last-child{
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// Login.vue?81455be2